// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Option navigation container */
.ua-option-navigation-container {
  width: 100px;
  height: 110px;
  border-radius: 20px;
  margin-top: 35px;
  display: flex;
  justify-content: flex-end;
  overflow: visible; /* ⭐ Allow overflow */
  margin-right: 0px;
  position: relative;
  z-index: 1000;
}

/* Dropdown menu */
.frn-menu-dropdown {
  position: absolute;
  top: calc(100% + 8px); /* ⭐ 8px below button */
  right: 0;
  background: black;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 300px;
  z-index: 9999; /* ⭐ Very high z-index */
  overflow: visible;
  animation: slideDown 0.2s ease-out;
  color: white;
  border-radius: 20px;
}

.frn-menu-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: gray;
  font-size: 16px;
}

.menu-dropdown-item:last-child {
  border-bottom: none;
}

.menu-dropdown-item:hover {
  background-color: #f5f5f5;
}

@keyframes slideDown {
  from {
      opacity: 0;
      transform: translateY(-10px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Group/Styles/GroupMenuDropdown.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,iBAAiB,EAAE,qBAAqB;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB,EAAE,uBAAuB;EAC9C,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EAEzB,0CAA0C;EAC1C,YAAY;EACZ,aAAa,EAAE,wBAAwB;EACvC,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,WAAW;EAEX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;MACI,UAAU;MACV,4BAA4B;EAChC;EACA;MACI,UAAU;MACV,wBAAwB;EAC5B;AACF","sourcesContent":["/* Option navigation container */\n.ua-option-navigation-container {\n  width: 100px;\n  height: 110px;\n  border-radius: 20px;\n  margin-top: 35px;\n  display: flex;\n  justify-content: flex-end;\n  overflow: visible; /* ⭐ Allow overflow */\n  margin-right: 0px;\n  position: relative;\n  z-index: 1000;\n}\n\n/* Dropdown menu */\n.frn-menu-dropdown {\n  position: absolute;\n  top: calc(100% + 8px); /* ⭐ 8px below button */\n  right: 0;\n  background: black;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  width: 300px;\n  z-index: 9999; /* ⭐ Very high z-index */\n  overflow: visible;\n  animation: slideDown 0.2s ease-out;\n  color: white;\n  border-radius: 20px;\n}\n\n.frn-menu-dropdown-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  color: gray;\n  font-size: 14px;\n  font-size: 16px;\n}\n\n.menu-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.menu-dropdown-item:hover {\n  background-color: #f5f5f5;\n}\n\n@keyframes slideDown {\n  from {\n      opacity: 0;\n      transform: translateY(-10px);\n  }\n  to {\n      opacity: 1;\n      transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
